import { useState } from 'react';
import { eachDayOfInterval, format, parseISO } from 'date-fns';
import { RegularRule, SpecificRule } from '../../models/ParkingRate.ts';
import {
  regularRuleToMaxFeeEntries,
  specificRuleToMaxFeeEntries,
  type MaxFeeRuleEntry,
} from '../../utils/ParkingRateConverters.ts';

interface UseParkingMaxFeeGroupsParams {
  initialRule?: RegularRule | SpecificRule;
  ruleTypeParam?: 'regular' | 'specific';
}

export function useParkingMaxFeeGroups({
  initialRule,
  ruleTypeParam,
}: UseParkingMaxFeeGroupsParams) {
  const [maxFeeEntries, setMaxFeeEntries] = useState<MaxFeeRuleEntry[]>(() => {
    if (!initialRule) return [];
    if (ruleTypeParam === 'regular') {
      return regularRuleToMaxFeeEntries(initialRule as RegularRule);
    }
    const initDates = eachDayOfInterval({
      start: parseISO(initialRule.effectivePeriod.startDateTime.split('T')[0]),
      end: parseISO(initialRule.effectivePeriod.endDateTime.split('T')[0]),
    }).map((d) => format(d, 'yyyy-MM-dd'));
    return specificRuleToMaxFeeEntries(initialRule as SpecificRule, initDates);
  });

  return { maxFeeEntries, setMaxFeeEntries };
}
